<template>
  <div class="template1-container">
    <!-- <img
      :src="backgroundPath"
      alt="certificate background"
      aria-hidden="true"
    /> -->
    <component :is="backgroundPath" aria-hidden="true"></component>
    <div class="specimen">{{ $t("specimen") }}</div>
    <div class="background">
      <div class="container">
        <div class="certificate-id">
          N
          <sup>o</sup>
          <span class="c-id">{{ certificateId }}</span>
        </div>
        <div class="logo1-container">
          <default-placeholder
            v-if="this.seriesData.certificate_template.logo.length === 0"
          ></default-placeholder>
          <img
            :src="this.seriesData.certificate_template.logo"
            alt="logo1"
            aria-hidden="true"
            v-else
          />
          <div
            class="image-ph wrap"
            v-if="this.seriesData.certificate_template.logo.length === 0"
          >
            {{ $t("template_1_logo_placeholder", currentCulture.culture) }}
          </div>
        </div>
        <div
          class="title-container wrap"
          :class="this.seriesData.certificate_template.color"
        >
          {{
            seriesData.certificate_template.resources[currentCulture.culture]
              .title
          }}
        </div>
        <div class="of-container center">
          {{ $t("to", currentCulture.culture) }}
        </div>
        <div class="name-container wrap center">
          {{ $t("template_1_name", currentCulture.culture) }}
        </div>
        <div class="description-container wrap center">
          <hr />
          {{
            seriesData.certificate_template.resources[currentCulture.culture]
              .description
          }}
        </div>
        <div class="logo2-container">
          <default-placeholder
            v-if="
              this.seriesData.certificate_template.logo_opt.length === 0 &&
              templateOptions.showLogo2
            "
          ></default-placeholder>
          <img
            :src="this.seriesData.certificate_template.logo_opt"
            alt="logo 2"
            aria-hidden="true"
            v-else-if="templateOptions.showLogo2"
          />
          <div
            class="image-ph wrap"
            v-if="
              this.seriesData.certificate_template.logo_opt.length === 0 &&
              templateOptions.showLogo2
            "
          >
            {{ $t("template_1_logo2_placeholder", currentCulture.culture) }}
          </div>
        </div>
        <div class="float-container">
          <div class="signatures-container">
            <div class="signature-container">
              <div class="signature-image-container">
                <default-placeholder
                  v-if="
                    this.seriesData.certificate_template.signature_logo
                      .length === 0
                  "
                ></default-placeholder>
                <img
                  :src="this.seriesData.certificate_template.signature_logo"
                  alt="Signature 1"
                  aria-hidden="true"
                  v-else
                />
                <div
                  class="image-ph wrap"
                  v-if="
                    seriesData.certificate_template.signature_logo.length === 0
                  "
                >
                  {{
                    $t(
                      "template_1_signature_placeholder",
                      currentCulture.culture
                    )
                  }}
                </div>
              </div>
              <hr />
              <div class="signature-text-container">
                <div class="name">
                  {{ seriesData.certificate_template.signature_name }}
                </div>
                <div class="position">
                  {{
                    seriesData.certificate_template.resources[
                      currentCulture.culture
                    ].signature_title
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="signatures-container opt"
            v-if="templateOptions.showSignature2"
          >
            <div class="signature-container">
              <div class="signature-image-container">
                <default-placeholder
                  v-if="
                    this.seriesData.certificate_template.signature_logo_opt
                      .length === 0
                  "
                ></default-placeholder>
                <img
                  :src="this.seriesData.certificate_template.signature_logo_opt"
                  alt="Signature 2"
                  aria-hidden="true"
                  v-else
                />
                <div
                  class="image-ph wrap"
                  v-if="
                    seriesData.certificate_template.signature_logo_opt
                      .length === 0
                  "
                >
                  {{
                    $t(
                      "template_1_signature_placeholder",
                      currentCulture.culture
                    )
                  }}
                </div>
              </div>
              <hr />
              <div class="signature-text-container">
                <div class="name">
                  {{ seriesData.certificate_template.signature_name_opt }}
                </div>
                <div class="position">
                  {{
                    seriesData.certificate_template.resources[
                      currentCulture.culture
                    ].signature_title_opt
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="date-container">
            <span class="date-text"
              >{{ $t("date", currentCulture.culture) }}:</span
            >
            <span class="date-value">{{ new Date().getDate() }}</span>
            <hr class="separator" />
            <span class="date-value">{{ months[new Date().getMonth()] }}</span>
            <hr class="separator" />
            <span class="date-value pr">{{ new Date().getFullYear() }}</span>
            <hr />
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Template1Blue from "@/assets/t1_bg_blue.svg";
import Template1Brown from "@/assets/t1_bg_brown.svg";
import Template1Green from "@/assets/t1_bg_green.svg";
import Template1Red from "@/assets/t1_bg_red.svg";
import DefaultPlaceholder from "@/assets/default_placeholder.svg";

export default {
  name: "template1",
  props: {
    templateOptions: Object,
    seriesData: Object,
    currentCulture: Object,
  },
  data() {
    return {
      certificateId: "0000000000",
      months: [
        this.$t("m0", this.currentCulture.culture),
        this.$t("m1", this.currentCulture.culture),
        this.$t("m2", this.currentCulture.culture),
        this.$t("m3", this.currentCulture.culture),
        this.$t("m4", this.currentCulture.culture),
        this.$t("m5", this.currentCulture.culture),
        this.$t("m6", this.currentCulture.culture),
        this.$t("m7", this.currentCulture.culture),
        this.$t("m8", this.currentCulture.culture),
        this.$t("m9", this.currentCulture.culture),
        this.$t("m10", this.currentCulture.culture),
        this.$t("m11", this.currentCulture.culture),
      ],
    };
  },
  computed: {
    backgroundPath() {
      switch (this.seriesData.certificate_template.color) {
        case "blue":
          return "Template1Blue";
        case "brown":
          return "Template1Brown";
        case "green":
          return "Template1Green";
        case "red":
          return "Template1Red";
        default:
          return "";
      }
    },
  },
  components: {
    Template1Blue,
    Template1Brown,
    Template1Green,
    Template1Red,
    DefaultPlaceholder,
  },
};
</script>

<style lang="scss" scoped>
$certificateSizeHeight: 774px;
$certificateSizeWidth: 1000px;
// body {
//   width: 11in;
//   height: 8.5in;
//   font-family: 'Lato', sans-serif;
// }

.template1-container {
  position: relative;
  display: inline-block;
}

.template1-container > svg {
  position: absolute;
  height: $certificateSizeHeight;
  width: $certificateSizeWidth;
  z-index: 0;
}

.rtl .template1-container .specimen {
  left: auto;
  bottom: auto;
  top: 375px;
  right: 40px;
}

.template1-container .specimen {
  position: absolute;
  transform: rotate(-35deg);
  @include fontSize(100px);
  text-align: center;
  letter-spacing: 30px;
  font-weight: bold;
  color: $bgLightGray;
  text-transform: uppercase;
  left: 40px;
  bottom: 375px;
  width: 1000px;
}

.background {
  height: $certificateSizeHeight;
  width: $certificateSizeWidth;
}

/* .background {
        background-image: url('assets/t1_bg_{color}.svg');
        background-repeat: no-repeat;
        background-size: contain;
      } */

hr {
  border: 0;
  border-top: 1.4px solid #e1e8f2;
  margin-bottom: 10px;
}

.clear {
  clear: both;
}

.container {
  border: 35px solid transparent;
  padding: 30px;
  position: relative;
  height: 100%;
}

.certificate-id {
  font-weight: bold;
  color: #868b93;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
}

.certificate-id span {
  padding-left: 5px;
}

.logo1-container {
  padding-top: 50px;
  position: relative;
  .image-ph {
    top: 59px;
    padding: 21px;
  }
}

.logo1-container > img {
  display: block;
  margin: auto;
  max-width: 300px;
  max-height: 100px;
}

.logo1-container > svg {
  height: 100px;
  display: block;
  margin: auto;
}

.title-container {
  font-family: "Times New Roman", Times, serif;
  font-size: 32px;
  font-size: 25.2px;
  line-height: 32px;
  text-align: center;
  padding-top: 15px;
  letter-spacing: 4.9px;
  font-weight: bold;
  max-width: 90%;
  margin: auto;
}

.red {
  color: $t1Red;
}

.blue {
  color: $t1Blue;
}

.green {
  color: $t1Green;
}

.brown {
  color: $t1Brown;
}

.of-container {
  padding: 15px 0;
  font-size: 9.8px;
  font-weight: bold;
  color: #041723;
}

.name-container {
  color: #041723;
  font-size: 25.2px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
}

.description-container {
  width: 50%;
  // width: 400px;
  margin: auto;
  color: #041723;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  hyphens: none;
}

.description-container hr {
  width: 28%;
  margin: 12px auto;
}

.logo2-container {
  height: 90px;
  position: absolute;
  bottom: 102px;
  right: 30px;

  .image-ph {
    top: 9px;
    right: 0;
    left: auto;
    padding: 21px;
  }
}

.logo2-container > img {
  max-height: 90px;
  max-width: 90px;
}

.logo2-container > svg {
  width: 90px;
}

.float-container {
  position: absolute;
  bottom: 30px;
  width: calc(100% - 30px);
}

.signatures-container {
  float: left;
}

.signature-container {
  max-width: 265px;
  margin-left: 24px;
  color: #041723;
  letter-spacing: 0;
  line-height: 15px;
  @include fontSize(11px);
}

.signature-container > hr {
  margin: 10px auto;
}

.signature-container {
  .signature-image-container {
    min-height: 90px;
    display: flex;
    align-items: center;
    position: relative;

    .image-ph {
      padding: 31px 19px;
    }

    > img {
      display: inline-block;
      margin: 0 auto;
      max-width: 265px;
      max-height: 90px;
    }

    > svg {
      display: inline-block;
      margin: 0 auto;
      height: 90px;
    }
  }
}

.name {
  font-weight: bold;
  padding-right: 5px;
}

.position {
  max-width: 265px;
  overflow-wrap: break-word;
  -ms-word-wrap: break-word;
  word-wrap: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  white-space: normal;
}

.date-container {
  float: right;
  padding: 90px 0 0 0;
  height: 15px;
  color: #041723;
  font-size: 11.9px;
  letter-spacing: 0;
  line-height: 15px;
  margin-right: 30px;
}

.date-container span {
  font-size: 9.8px;
  font-weight: bold;
}

.date-container .date-text {
  margin-right: 45px;
}

.date-container .date-value {
  font-size: 11px;
}

.date-container .date-value.pr {
  padding-right: 30px;
}

.separator {
  transform: rotate(-69deg);
  display: inline-block;
  height: 1px;
  width: 30px;
  margin-bottom: 0;
}

.image-ph {
  width: 90px;
  height: 90px;
  font-weight: bold;
  text-align: center;
  position: absolute;
  padding: 23px 19px;
  @include fontSize(11px);
  line-height: 16px;
  left: 50%;
  margin-left: -45px;
}
</style>
